/**
 * Module dependencies.
 */

import { AxiosInstance } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * Resend verification email.
 */

function resendVerification(client: AxiosInstance, email: string): Promise<void> {
  return client.post(resolveAppUrl('resendVerification'), { email }).then(({ data }) => data);
}

/**
 * `Options` type.
 */

type Options = UseMutationOptions<void, unknown, string, unknown>;

/**
 * Export `useResendVerification`.
 */

export function useResendVerification(options?: Options) {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (email: string) => {
      return await resendVerification(client, email);
    },
    ...options
  });
}
